import type { AnalyticsSurface } from '@/shared/surfaces/AnalyticsSurface';
import ClassificationSurfaceCard from '@/features/classification/ClassificationSurfaceCard';
import { TOKEN_USAGE_CATALOG } from './TokenUsageTopicCatalog';
import { TOKEN_USAGE_INTERACTION_COLUMNS } from './TokenUsageInteractionColumns';
import TokenUsageRegisterBody from './TokenUsageRegisterBody';

/** The Token Usage surface: an Activity/Analytics tabbed landing over token volume and license spend, with topic drill-ins. */
export const TOKEN_USAGE_SURFACE: AnalyticsSurface = {
    id: 'token-usage',
    basePath: '/token-usage',
    title: 'Token Usage',
    subtitle: 'Where AI consumption actually goes. Token volume is the proxy for what AI usage costs; the Cost section carries the hard dollars.',
    catalog: TOKEN_USAGE_CATALOG,
    gallery: { statTiles: ['totalTokens', 'outputTokens', 'users', 'sessions'], lead: 'none', cardStyle: 'standard', columns: { base: 1, md: 2 }, signals: true },
    assist: true,
    drillStyle: 'side-rail',
    evidenceColumns: TOKEN_USAGE_INTERACTION_COLUMNS,
    evidenceStyle: 'consumption',
    registerBody: TokenUsageRegisterBody,
    trailingCard: <ClassificationSurfaceCard category="FinOps" variant="standard" />,
};
